import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import ajaxUser from "../../util/remote/ajaxUser";
import dictionary from "../../util/dictionary";
const UserProfile = () => {
  const { userId, getUserInfo } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  // Tabs state
  const [activeTab, setActiveTab] = useState("about");
  // Profile states
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [username, setUsername] = useState("");
  // Password states
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  // Fetch user info
  const getUserInfos = async () => {
    let data = { user_id: userId };
    const server_response = await ajaxUser.fetchSingleUser(data);
    if (server_response.status === "OK") {
      const details = server_response.details;
      setUser(details);
      setFirstName(details.first_name || "");
      setLastName(details.last_name || "");
      setEmail(details.email || "");
      setContact(details.contact || "");
      setUsername(details.username || "");
    }
  };
  useEffect(() => {
    getUserInfos();
  }, []);
  // Profile update
  const handleProfileUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    let data = {
      user_id: userId,
      first_name: firstName,
      last_name: lastName,
      username: username,
      email: email,
      contact: contact,
    };
    const server_response = await ajaxUser.updateUserProfile(data);
    if (server_response.status === "OK") {
      getUserInfo();
      toast.success(server_response.message);
    } else {
      toast.error(server_response.message);
    }
    setLoading(false);
  };
  // Password update
  const handlePasswordUpdate = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }
    let data = {
      user_id: userId,
      old_password: oldPassword,
      new_password: newPassword,
    };
    const server_response = await ajaxUser.updatePassword(data);
    if (server_response.status === "OK") {
      toast.success(server_response.message);
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
      onLogout();
    } else {
      toast.error(server_response.message);
    }
  };
  const onLogout = () => {
    localStorage.removeItem("FuelFy@daisy");
    navigate("/");
    window.location.reload();
  };
  if (!user) {
    return (
      <AppContainer title="User Profile">
        <div className="container-fluid">
          <Toaster />
          <p>Loading user profile...</p>
        </div>
      </AppContainer>
    );
  }
  return (
    <AppContainer title="User Profile">
      <div className="container-fluid">
        <Toaster />
        {/* Profile Header */}
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card shadow-sm border-0">
              <div className="card-body text-center p-4">
                <img
                  src={`${dictionary.apiHost}${user.photo}`}
                  alt="Profile"
                  className="rounded-circle mb-3 shadow"
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "cover",
                  }}
                />
                <h3 className="fw-bold mb-0">
                  {user.first_name} {user.last_name}
                </h3>
                <p className="text-muted">{user.role?.role_name}</p>
              </div>
              {/* TABS USING STATE */}
              <div className="profile-tab">
                <nav className="nav nav-pills nav-fill bg-light rounded-top">
                  <button
                    className={`btn btn-success m-1  btn-rounded${
                      activeTab === "about" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("about")}
                  >
                    About
                  </button>
                  <button
                    className={`btn btn-info m-1  btn-rounded${
                      activeTab === "edit" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("edit")}
                  >
                    Edit Profile
                  </button>
                  <button
                    className={`btn btn-warning m-1  btn-rounded${
                      activeTab === "password" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("password")}
                  >
                    Change Password
                  </button>
                </nav>
              </div>
            </div>
          </div>
        </div>
        {/* Tab Content */}
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="card custom-card shadow-sm border-0">
              <div className="p-4">
                {/* ABOUT TAB */}
                {activeTab === "about" && (
                  <div>
                    <h5 className="fw-bold text-primary mb-3">
                      Profile Overview
                    </h5>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <div className="d-flex align-items-center p-3 border rounded shadow-sm bg-light">
                          <i className="fa fa-key text-primary fs-4 me-3"></i>
                          <div>
                            <small className="text-muted d-block">Name</small>
                            <span className="fw-semibold">
                              {user.first_name} {user.last_name}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="d-flex align-items-center p-3 border rounded shadow-sm bg-light">
                          <i className="fa fa-user-circle text-primary fs-4 me-3"></i>
                          <div>
                            <small className="text-muted d-block">
                              Username
                            </small>
                            <span className="fw-semibold">{user.username}</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="d-flex align-items-center p-3 border rounded shadow-sm bg-light">
                          <i className="fa fa-envelope text-success fs-4 me-3"></i>
                          <div>
                            <small className="text-muted d-block">Email</small>
                            <span className="fw-semibold">{user.email}</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="d-flex align-items-center p-3 border rounded shadow-sm bg-light">
                          <i className="fa fa-phone text-warning fs-4 me-3"></i>
                          <div>
                            <small className="text-muted d-block">
                              Contact
                            </small>
                            <span className="fw-semibold">{user.contact}</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="d-flex align-items-center p-3 border rounded shadow-sm bg-light">
                          <i className="fa fa-briefcase text-info fs-4 me-3"></i>
                          <div>
                            <small className="text-muted d-block">Role</small>
                            <span className="fw-semibold">
                              {user.role?.role_name}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="d-flex align-items-center p-3 border rounded shadow-sm bg-light">
                          <i
                            className={`fa ${
                              user.is_active === "1"
                                ? "fa-check-circle text-success"
                                : "fa-times-circle text-danger"
                            } fs-4 me-3`}
                          ></i>
                          <div>
                            <small className="text-muted d-block">Status</small>
                            <span className="fw-semibold">
                              {user.is_active === "1" ? "Active" : "Inactive"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* EDIT PROFILE TAB */}
                {activeTab === "edit" && (
                  <div>
                    <h5 className="fw-bold text-primary mb-3">Edit Profile</h5>
                    <form onSubmit={handleProfileUpdate}>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="form-label">First Name</label>
                          <input
                            type="text"
                            className="form-control shadow-sm"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Last Name</label>
                          <input
                            type="text"
                            className="form-control shadow-sm"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Username</label>
                          <input
                            type="text"
                            className="form-control shadow-sm"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Email</label>
                          <input
                            type="email"
                            className="form-control shadow-sm"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Phone</label>
                          <input
                            type="text"
                            className="form-control shadow-sm"
                            value={contact}
                            onChange={(e) => setContact(e.target.value)}
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Role</label>
                          <input
                            type="text"
                            className="form-control shadow-sm"
                            value={user.role?.role_name}
                            readOnly
                          />
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mt-3 px-4 shadow"
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? "Saving..." : "Save Changes"}
                      </button>
                    </form>
                  </div>
                )}
                {/* CHANGE PASSWORD TAB */}
                {activeTab === "password" && (
                  <div>
                    <h5 className="fw-bold text-primary mb-3">
                      <i className="fa fa-lock me-2"></i> Change Password
                    </h5>
                    <form onSubmit={handlePasswordUpdate}>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Old Password</label>
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control shadow-sm"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                            required
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label">New Password</label>
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control shadow-sm"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Confirm Password</label>
                          <input
                            type={showPassword ? "text" : "password"}
                            className={`form-control shadow-sm ${
                              confirmPassword && confirmPassword !== newPassword
                                ? "is-invalid"
                                : confirmPassword &&
                                  confirmPassword === newPassword
                                ? "is-valid"
                                : ""
                            }`}
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                          />
                          {confirmPassword && (
                            <small
                              className={`d-block mt-1 ${
                                confirmPassword === newPassword
                                  ? "text-success"
                                  : "text-danger"
                              }`}
                            >
                              {confirmPassword === newPassword
                                ? "Passwords match ✅"
                                : "Passwords do not match ❌"}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="form-check mb-3">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="showPassword"
                          checked={showPassword}
                          onChange={() => setShowPassword(!showPassword)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="showPassword"
                        >
                          Show Passwords
                        </label>
                      </div>
                      <button
                        className="btn btn-warning mt-2 px-4 shadow"
                        type="submit"
                        disabled={
                          !newPassword || newPassword !== confirmPassword
                        }
                      >
                        <i className="fa fa-key me-2"></i> Update Password
                      </button>
                    </form>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  );
};
export default UserProfile;
